import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";

export const VersionSelectorContainer = styled(Paper)(({ theme }) => ({
    position: 'absolute',
    top: 16,
    right: 16,
    zIndex: 1000,
    padding: theme.spacing(1.5),
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: 'calc(100% - 32px)',
    alignItems: 'center',
    gap: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    borderRadius: theme.shape.borderRadius
}));

export const LanguageSelect = styled(Select)(({ theme }) => ({
    minWidth: 120,
    height: 40
}));

export const LabelTypography = styled(Typography)({
    fontWeight: "bold"
});